import { NgModule } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { COMMON_IMPORTS } from './common-imports';
import { ModalComponent } from './components/modal/modal.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@NgModule({
    imports: [
        ModalModule.forRoot(),
        COMMON_IMPORTS,
        CommonModule,
        RouterModule
    ],
    declarations: [
        ModalComponent
    ],
    exports: [
        ModalModule,
        ModalComponent
    ],
    providers: []
})
export class SharedModule { }
